import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Label, Table } from 'reactstrap'
import { CommonHeader, ErrorSuccessModal, Loader } from '../../../components/commons'
import { PaperClipIcon } from '../../../components/Icon'
import { getAdminOpenItemsSingleAction, getAllOpenItemCommentsAction, resetOpenItemsCommentList, resetOpenItemsSuccess, resetSingleOpenItem } from '../../../redux/openItems'
import { RootState } from '../../../redux/rootReducers'
import { formatDate } from '../../../utils/commonFunctions'
import { CommentsModal } from '../../../components/OpenItems'
import { GetAllOpenItemCommentsPayload } from '../../../commonTypes/openItemsTypes'
import { OpenItemsCommentType } from '../../../redux/openItems/openItemsTypes'
import { singleImagePreview } from '../../../utils/invoiceGeneration/commonFunctions'
import { ImageDataType } from '../../../commonTypes/fileManagerTypes'
import ImageModal from './ImageModal'
import { resetAuthError, resetSession } from '../../../redux/auth'
type AppProps = {
    token: string | null;
    fetching: boolean;
    success: number | null;
    statusCode: number | null;
    error: string | null;
    dispatchGetAdminOpenItemsSingle: (data: any) => void;
    dispatchResetOpenItemsCommentList: () => void;
    dispatchResetSingleOpenItem: () => void;
    adminOpenItemSingle: any;
    openItemsCommentsList: [] | OpenItemsCommentType[];
    dispatchGetAllOpenItemCommentsAction: (data: GetAllOpenItemCommentsPayload) => void;
    dispatchResetSession: () => void;
    dispatchResetError: () => void;
    dispatchResetOpenItemsSuccess: () => void;
}


const ViewOpenItemsProgressReports = ({
    token,
    fetching,
    success,
    error,
    dispatchGetAdminOpenItemsSingle,
    adminOpenItemSingle,
    openItemsCommentsList,
    dispatchGetAllOpenItemCommentsAction,
    dispatchResetOpenItemsCommentList,
    dispatchResetSingleOpenItem,
    dispatchResetSession,
    dispatchResetError,
    statusCode,
    dispatchResetOpenItemsSuccess
}: AppProps) => {

    const { openItemId }: any = useParams()
    const [finalDocument, setFinalDocument] = useState<any[]>([])
    const [showCommentModal, setShowCommentModal] = useState<boolean>(false);
    const [allOpenItemComments, setAllOpenItemComments] = useState<any[]>([]);
    const [commentsModalData, setCommentsModalData] = useState<any>();
    const [showPopUpContentModal, setShowPopUpContentModal] = useState<boolean>(false)
    const [showImagePreview, setShowImagePreview] = useState<boolean>(false)
    const [uploadData, setUploadData] = useState<any[]>([]);
    const [imageDetails, setImageDetails] = useState<ImageDataType>({
        imageUrl: "",
        downloadImage: "",
        fileType: "",
        finalFileName: "",
        updateBy: "",
        updatedAt: ""
    })
    let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
    let blobToken = process.env.REACT_APP_BLOB_TOEKN;

    const {
        summary = '',
        job_id,
        job_type,
        documents = [],
        client_code,
        client_name,
        status_code
    } = adminOpenItemSingle

    useEffect(() => {
        dispatchResetOpenItemsCommentList();
        dispatchResetSingleOpenItem();
        dispatchResetOpenItemsSuccess();
        if (token && openItemId) {
            const finalData = {
                token,
                jobId: openItemId
            }
            dispatchGetAdminOpenItemsSingle(finalData)
        }
    }, [])
    
    const status = (status_code: number) => {
        if (status_code === 0) return 'Pending'
        if (status_code === 1) return 'Incomplete'
        if (status_code === 2) return 'Approval Pending'
        if (status_code === 3) return 'Complete'
    }

    useEffect(() => {
        const {
            documents = [],
        } = adminOpenItemSingle;
        setFinalDocument(documents)
    }, [adminOpenItemSingle])

    useEffect(() => {
        if (openItemsCommentsList) {
            setAllOpenItemComments(openItemsCommentsList);
        }
    }, [openItemsCommentsList]);

    useEffect(() => {
        resetImageUrl()
        const imageFile = uploadData?.map((data: any, index: number) => {
            let file_type = data.file_url.split(".")
            if (file_type[file_type.length - 1] === "png" || file_type[file_type.length - 1] === "jpg" || file_type[file_type.length - 1] === "jpeg") {
                return data
            }
            else {
                setImageDetails(
                    {
                        ...uploadData[0],
                        imageUrl: blobBaseUrl + uploadData[0].file_url + '?' + blobToken,
                        downloadImage: uploadData[0].file_url,
                        fileType: uploadData[0].file_type,
                        finalFileName: uploadData[0].file_name
                    })
            }
        })
        if (imageFile?.length > 0) {
            if (imageFile[0]?.file_url) {
                getImageDetails(imageFile[0], "j")
            }
        }
    }, [uploadData])

    const download = () => {
        if (blobBaseUrl && imageDetails?.downloadImage) {
            return <a href={blobBaseUrl + imageDetails?.downloadImage + '?' + blobToken} ></a>
        }

    }

    const getStatus = (status: any) => {
        switch (true) {
            case (status == 1):
                return 'no-status';
            case (status === 2):
                return 'Rejected';
            case (status === 3):
                return 'Approved';
            default: return;
        }
    }

    const returnFileFormat = (format: string) => {
        switch (format) {
            case 'image':
                return 'Image';
            case 'word':
                return 'Word';
            case 'pdf':
                return 'PDF';
            case 'excel':
                return 'Excel';
            case 'hard_copy':
                return 'Hard Copy';
            default:
                return 'Image';
        }
    }

    //view Uploaded file
    const getImageDetails = (data: any, index: any) => {
        setImageDetails(
            {
                ...data,
                imageUrl: blobBaseUrl + data.file_url + '?' + blobToken,
                downloadImage: data.file_url,
                fileType: data.file_type,
                finalFileName: data.file_name
            })
    }

    const renderFilesList = () => {
        const isDelete = false;
        const finalFileList =
            uploadData?.length > 0 &&
            uploadData?.map((data: any, index: number) => {
                return singleImagePreview(data, index, getImageDetails, handleEditFileList, setShowPopUpContentModal, isDelete, uploadData)
            });
        return finalFileList;
    };

    const handleEditFileList = (index: number) => {
        JSON.parse(JSON.stringify(uploadData));
    };

    const renderDocuments = () => {
        return finalDocument && finalDocument?.length && finalDocument?.map((item: any, i: number) => {
            const finalComment = item?.last_comment?.length > 15 ? `${item?.last_comment.slice(0, 15)}...` : item?.last_comment;
            return <tr key={i}>
                <td className='col-2 text-center'>{item?.item_name}</td>
                <td className='col-2 text-center'><span className={`file-status-${item?.format}`}>{returnFileFormat(item?.format)}</span></td>
                <td className='col-2 text-center' style={{ width: '100px' }}>{formatDate(item?.due_date)}</td>
                <td className='col-2 text-center' style={{ width: '120px' }} key={i} >
                    {
                        item.upload.length ? <span >
                            <span className="position-relative pointer" onClick={() => {
                                setUploadData(item?.upload)
                                setShowImagePreview(!showImagePreview)
                            }}>
                                <span className='position-relative'><PaperClipIcon /></span>
                                <span className="badge count-badge" style={{ marginLeft: '-9px' }}>
                                    {item?.upload?.length}
                                </span>
                            </span>
                            <span className='position-absolute' style={{ top: '-200px' }}>
                            </span>
                        </span> : <span> --/-- </span>
                    }
                </td>
                <td className='text-center'>{finalComment ?
                    <>
                        <span>{finalComment}</span><br />
                        <span className="due-date-text">{moment.utc(item?.last_comment_date).local().format('DD-MM-YY, h:mm a')}</span>
                    </> :
                    '--/--'
                }</td>
                <td className='col-2 text-center'>
                    <span className={`status-${getStatus(item?.approval_status_code)}`}>
                        {item?.approval_status_code !== 1 ? getStatus(item?.approval_status_code) : 'No Status'}
                    </span>
                </td>
                <td>
                    <i
                        className="fas fa-comments comment-icon"
                        onClick={() => handleCommentsModalData(item)}
                    ></i>
                </td>
            </tr>
        })
    }

    const handleToggleCommentsModal = () => {
        setShowCommentModal(!showCommentModal);
        dispatchResetOpenItemsCommentList()
    }

    const renderCommentsModal = (data?: any) => {
        setCommentsModalData(data);
        if (token && data?.item_id) {
            let finalData: GetAllOpenItemCommentsPayload = {
                item_id: data?.item_id,
                token,
                open_item_id: +openItemId
            }
            dispatchGetAllOpenItemCommentsAction(finalData)
        }
    }

    const handleCommentsModalData = (data: any) => {
        handleToggleCommentsModal();
        renderCommentsModal(data);
    }

    const getStatusClass = (status: number) => {
        switch (status) {
            case 0:
                return 'pending';
            case 1:
                return 'incomplete';
            case 2:
                return 'approval-pending';
            case 3:
                return 'complete';
            default:
                return;
        }
    }

    const resetImageUrl = () => {
        setImageDetails({
            imageUrl: "",
            downloadImage: "",
            fileType: "",
            finalFileName: "",
            updateBy: "",
            updatedAt: ""
        })
    }

    const handleErrorModal = () => {
        if (success === 0) {
            if (statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message="Session Expired. Please Login Again!"
                        buttonText="Logout"
                        onPress={() => dispatchResetSession()}
                        statusCode={statusCode}
                    />
                )
            } else if ((!!error && statusCode !== 401)) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="OK"
                        onPress={() => {
                            dispatchResetError()
                        }}
                    />
                )
            }
        }
        return false;
    };

    return (
        <div className='row'>
            <div className="col-md-6 mb-3">
                <CommonHeader title="View Open Items" />
            </div>
            <div className="col-md-12 mt-4">
                <div className="content-area">
                    <div className="row">
                        <div className="col-12">
                            <div
                                className='mb-2'
                            >
                                <span style={{ fontSize: '19px', color: "#262a44" }}>{`${client_name}`} </span>
                                <span style={{ border: "1px solid #bfcbe1", borderRadius: '10px', padding: "1px 10px", color: "#7c8db0" }}>{`CC-${client_code}`}</span>
                            </div>

                        </div>
                    </div>
                    <div className='row'>
                        <div className={`col-${summary?.length > 60 ? 2 : 4}`}>
                            <Label>Job Type</Label>
                            <div>{`${job_type} (${job_id})`}</div>
                        </div>
                        <div className={`col-${summary?.length > 60 ? 6 : 4}`}>
                            <Label>Summary</Label>
                            <p>{summary}</p>
                        </div>
                        <div className={`col-${summary?.length > 60 ? 4 : 4}`}>
                            <Label>Status</Label>
                            <p className={`status-${getStatusClass(status_code)} text-center`} style={{ maxWidth: status(status_code) === "Approval Pending" ? '140px' : '100px' }}>{status(status_code)}</p>
                        </div>
                    </div>
                    <div className='table-bordered'>
                        <Table className="table table-striped">
                            <thead>
                                <tr className="mt-3 text-center">
                                    <th>Item name</th>
                                    <th>Format</th>
                                    <th>
                                        Due Date
                                    </th>
                                    <th>
                                        Upload File
                                    </th>
                                    <th>
                                        Last Commented
                                    </th>

                                    <th>
                                        Approve/Reject
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {renderDocuments()}
                            </tbody>
                        </Table>

                    </div>
                </div>
                {
                    showCommentModal && <CommentsModal
                        modal={showCommentModal}
                        toggleModal={handleToggleCommentsModal}
                        data={commentsModalData}
                        allOpenItemComments={allOpenItemComments}
                    />
                }
                {showImagePreview && <ImageModal
                    showImagePreview={showImagePreview}
                    setShowImagePreview={setShowImagePreview}
                    resetImageUrl={resetImageUrl}
                    imageDetails={imageDetails}
                    renderFilesList={renderFilesList}
                    uploadData={uploadData}
                    setUploadData={setUploadData}
                // setPdfDownload={setPdfDownload}
                />}
                {fetching && <Loader />}
                {handleErrorModal()}
            </div>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    token: state.auth.token,
    adminOpenItemSingle: state.openItems.adminOpenItemSingle,
    fetching: state.openItems.fetching,
    success: state.openItems.success,
    error: state.openItems.error,
    statusCode: state.openItems.statusCode,
    openItemsCommentsList: state.openItems.openItemsCommentsList
})

const mapDispatchToProps = (dispatch: any) => ({
    dispatchGetAdminOpenItemsSingle: (data: any) => dispatch(getAdminOpenItemsSingleAction(data)),
    dispatchResetOpenItemsCommentList: () => dispatch(resetOpenItemsCommentList()),
    dispatchResetSingleOpenItem: () => dispatch(resetSingleOpenItem()),
    dispatchGetAllOpenItemCommentsAction: (data: GetAllOpenItemCommentsPayload) =>
        dispatch(getAllOpenItemCommentsAction(data)),
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchResetError: () => dispatch(resetAuthError()),
    dispatchResetOpenItemsSuccess: () => dispatch(resetOpenItemsSuccess()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ViewOpenItemsProgressReports)